/**
 * External store for the "session expired" state.
 *
 * Lives outside React so non-React code (axios interceptors) and AuthProvider can
 * signal expiry, and AppContent can render the session-expired screen inline at
 * the current URL via `useSyncExternalStore` (same pattern as forbiddenStore).
 */

import type { ExpiredSession } from './sessionExpiredStore.types';

type Listener = () => void;

let expiredSession: ExpiredSession | null = null;
const listeners = new Set<Listener>();

function emitChange(): void {
  listeners.forEach(listener => listener());
}

export function setSessionExpired(session: ExpiredSession): void {
  expiredSession = session;
  emitChange();
}

export function getSnapshot(): ExpiredSession | null {
  return expiredSession;
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Reset session-expired state. Used in tests to clean up between test cases.
 */
export function resetSessionExpiredStore(): void {
  expiredSession = null;
  emitChange();
}
